import React, { PureComponent } from 'react';
import { addVAT } from './utils';

function calculateInterest(creditAmount, interest) {
    let calculatedInterest = interest / 100;
    return (creditAmount * calculatedInterest) / 12;
}
/*
<div className={`${this.props.classPrefix}-acquisition-price`}>
            <div>Anskaffningspris inklusive moms</div>
            <div>{formatter(addVAT(this.props.acquisitionPrice, this.props.vat))}</div>
            <div>{this.props.periodicity === 'month' ? this.props.term : this.props.term / 3} {t(this.props.periodicity === 'month' ? 'Months' : 'Quarters')}</div>
          </div>
          <div className={`${this.props.classPrefix}-down-payment`}>
            <div>Kontantinsats</div>
            <div>{formatter(this.props.downPayment)}</div>
            <div>rak amortering</div>
          </div>
          <div className={`${this.props.classPrefix}-trade-in`}>
            <div>Avgår netto inbytesvärde</div>
            <div>{formatter(addVAT(this.props.tradeInIncVAT, this.props.vat))}</div>
            <div>räntesats		{percentFormatter(this.props.interest)}</div>
          </div>
          <div className={`${this.props.classPrefix}-`}>
            <div>Kreditbelopp</div>
            <div>{formatter(this.props.creditAmount)}</div>
            <div></div>
          </div>
          <div className={`${this.props.classPrefix}-`}>
            <div>Aviserings- och uppläggningsavgift tillkommer.</div>
            <div></div>
            <div></div>
          </div>
 */

function createAmortizationRows(periodicity, term, creditAmount, increasedAmortizationAmount, amortizationAmount, interest) {
  const multiplier = periodicity === 'month' ? 1 : 3;
  const increasedPaymentPeriod = periodicity === 'month' ? 3 : 1;
  const amortizationRows = [];
  let arrear = creditAmount;
  const terms = Math.ceil(term / multiplier);
  for (let i = 1; i <= terms; i += 1) {
    let amortization = i === increasedPaymentPeriod ? increasedAmortizationAmount + amortizationAmount : amortizationAmount;
    if (amortization > arrear) {
      amortization = arrear;
    }
    const nextInterest = calculateInterest(arrear, interest);
    const payment = nextInterest + amortization;
    arrear = arrear - amortization;
    amortizationRows.push({
      period: i,
      payment,
      interest: nextInterest,
      amortization,
      arrear,
    });
  }
  return amortizationRows;
}

export default class AmortizationTab extends PureComponent {
  static getDerivedStateFromProps(nextProps, prevState) {
    return {
      amortizationRows: createAmortizationRows(nextProps.periodicity, nextProps.term, nextProps.creditAmount, nextProps.increasedAmortizationAmount, nextProps.amortizationAmount, nextProps.interest),
    }
  }

  constructor(props) {
    super(props);
    this.state = {
      amortizationRows: createAmortizationRows(props.periodicity, props.term, props.creditAmount, props.increasedAmortizationAmount, props.amortizationAmount, props.interest),
    }
  }
  render() {
    const t = this.props.t;
    const formatter = this.props.formatter;
    const percentFormatter = this.props.percentFormatter;
    return (<div className={`${this.props.classPrefix}-amortization-tab`}>
      <div className={`${this.props.classPrefix}-summary`}>
        <div>{t('Interest:')} {percentFormatter(this.props.interest)}</div>
        <div>{t('Credit amount (inc. VAT):')} {formatter(this.props.creditAmount)}</div>
        <div>{t('Repayment period:')} {this.props.periodicity === 'month' ? this.props.term : Math.ceil(this.props.term / 3)} {t(this.props.periodicity === 'month' ? 'Months' : 'Quarters')}</div>
        </div>
        <div className="mobile-text">
            <img src="/Frontend/images/icon-rotate.png" alt=""/>
        </div>
        <div className={`${this.props.classPrefix}-amortization`}>
            <div className="table-responsive">
        <table className="table">
          <thead>
           <tr className="table-header">
            <th>Period</th>
            <th>Betalning</th>
            <th>Ränta</th>
            <th>Amortering</th>
            <th>Restskuld efter amortering</th>
          </tr>
          </thead>
          <tbody>
          {this.state.amortizationRows.map(r => (<tr key={r.period}>
            <td>{r.period}</td>
            <td>{formatter(r.payment)}</td>
            <td>{formatter(r.interest)}</td>
            <td>{formatter(r.amortization)}</td>
            <td>{formatter(r.arrear)}</td>
          </tr>))}
          </tbody>
        </table>
       </div>
      </div>
    </div>);
  }
}
